import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { round } from '../SuskaiciuotasAtsakymas';

const ScoreDisplay = ({ value, comparisonValue, year, showComparison, t }) => {
    if ((year === '2023' || year === '2024') && (!value || value === '')) {
        return <p className="atsakmyasRezultatas">{t('nevertinama')}</p>;
    }

    return (
        <p className="atsakmyasRezultatas">
            {value && value !== 0 ? round(value, 0.5) : '0'}
            {comparisonValue !== undefined && showComparison && (
                <Tooltip title={t('palyginus_su_vidurkiu')} placement="top">
                    <span className="atsakmyasRezultatasPilkas">
                        ({round(comparisonValue, 0.5)})
                    </span>
                </Tooltip>
            )}
        </p>
    );
};

ScoreDisplay.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    comparisonValue: PropTypes.number,
    year: PropTypes.string.isRequired,
    showComparison: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired
};

export default memo(ScoreDisplay);
